import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/portal/managers/shifts')({
  beforeLoad: () => {
    throw redirect({ to: '/portal/managers/hr/shifts' });
  },
});
